import {
  GetMainTableQueryParams,
  fetchMainTableDocuments,
} from '@dc-shared-web/hooks/api/document/fetchMainTableDocuments'
import {
  DOCUMENTS_QUERY_KEY,
  LIST_QUERY_KEY,
} from '@dc-shared-web/hooks/api/queryKeys'
import { useAxiosContext } from '@dc-shared-web/providers'
import { useInfiniteQuery } from 'react-query'

export const useGetMainTableDocuments = (
  params: Omit<GetMainTableQueryParams, 'offset'>
) => {
  const apiClient = useAxiosContext()

  return useInfiniteQuery({
    queryKey: [
      DOCUMENTS_QUERY_KEY,
      LIST_QUERY_KEY,
      //this has to go after documents list in the query key
      //to allow us to invalidate all documents lists (otherwise the matching doesn't work)
      params.currentTable,
      params,
    ],
    queryFn: async ({ pageParam }) => {
      const response = await fetchMainTableDocuments(apiClient, {
        ...params,
        offset: pageParam ?? 0,
      })
      return response
    },
    getNextPageParam: (lastPage, pages) => {
      return lastPage.data.length > 0
        ? pages.reduce((prev, page) => prev + page.data.length, 0)
        : undefined
    },
  })
}
